import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const SERVICES = [
  {
    icon: '◈',
    title: 'Web Development',
    desc: 'Premium landing pages and web apps engineered for speed, conversions, and clean UX.',
    accent: '#7C5CFC',
    accentSoft: 'rgba(124,92,252,0.35)',
    accentFaint: 'rgba(124,92,252,0.14)',
  },
  {
    icon: '◉',
    title: 'App Development',
    desc: 'Cross-platform mobile apps with polished UI, offline readiness, and store launch support.',
    accent: '#00D4FF',
    accentSoft: 'rgba(0,212,255,0.35)',
    accentFaint: 'rgba(0,212,255,0.14)',
  },
  {
    icon: '◍',
    title: 'SEO & Growth',
    desc: 'Technical SEO, content planning, and analytics to push you up the rankings.',
    accent: '#FFB86B',
    accentSoft: 'rgba(255,184,107,0.35)',
    accentFaint: 'rgba(255,184,107,0.16)',
  },
  {
    icon: '◎',
    title: 'Cloud & DevOps',
    desc: 'Empowering your business with scalable cloud architectures and automated DevOps workflows for faster, more reliable releases.',
    accent: '#9E7BFF',
    accentSoft: 'rgba(158,123,255,0.35)',
    accentFaint: 'rgba(158,123,255,0.16)',
  },
  {
    icon: '◐',
    title: 'AI Automation',
    desc: 'AI chatbots, workflow automation, and smart CRM integrations that run 24/7.',
    accent: '#7FE7FF',
    accentSoft: 'rgba(127,231,255,0.35)',
    accentFaint: 'rgba(127,231,255,0.16)',
  },
  {
    icon: '◑',
    title: 'Data & Insights',
    desc: 'Dashboards, pipelines, and reporting that turn raw data into decisions.',
    accent: '#F5A97F',
    accentSoft: 'rgba(245,169,127,0.35)',
    accentFaint: 'rgba(245,169,127,0.16)',
  },
];

export default function Services() {
  const ref = useRef(null);

  useEffect(() => {
    gsap.from(ref.current.querySelectorAll('.srv-card'), {
      opacity: 0, y: 48, stagger: 0.09, duration: 0.7, ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: { trigger: ref.current, start: 'top 76%' },
    });
    gsap.from(ref.current.querySelector('.srv-head'), {
      opacity: 0, y: 30, duration: 0.7, ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: { trigger: ref.current, start: 'top 82%' },
    });

    // Ensures ScrollTrigger calculates correct positions after mount.
    ScrollTrigger.refresh();
  }, []);

  return (
    <section id="services" ref={ref} className="section">
      <div className="container">
        <div className="section-heading srv-head">
          <p className="eyebrow">What We Do</p>
          <h2 className="heading">
            Every service your business<br />
            <span className="gradient-text">actually needs.</span>
          </h2>
        </div>

        <div className="cards-grid">
          {SERVICES.map((s) => (
            <div
              key={s.title}
              className="card services-card srv-card"
              style={{
                '--accent': s.accent,
                '--accent-soft': s.accentSoft,
                '--accent-faint': s.accentFaint,
              }}
            >
              <div className="services-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              {/* <div className="learn">Learn more →</div> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
